export default "https://cdn-static.gokick.com/assets/9175df2ab050434674d4a27e4dae3ab0ebb22d80/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";